// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import axios from 'axios'
// import Element from 'element-ui'
// import qs from 'qs'
// import 'element-ui/lib/theme-chalk/index.css'
import Vant, { Lazyload } from 'vant';
// import { Lazyload } from 'vant';
import 'animate.css';
import "video.js/dist/video-js.css";
import 'vant/lib/index.css';
// import { postApi } from './assets/api'
import "lib-flexible";
import './styles/style.scss';
// import store from '@/store';
// import Vconsole from 'vconsole'

//npm i -S weixin-js-sdk
// let vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.use(Vant)
Vue.use(Lazyload);
Vue.directive('intersect', {
  bind: function (el, binding, vnode) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 图片进入视口后添加类名
          el.classList.add(binding.value);
          el.classList.add('op1');
          // observer.unobserve(el); // 停止观察
        } else {
          el.classList.remove(binding.value);
          el.classList.remove('op1');
        }
      });
    }, {
      threshold: 0 // 当元素至少50%出现在视口时触发
    });

    observer.observe(el);
  },
});
Vue.directive('animate', {
  //inserted是指令的生命周期函数，指再页面中插入此元素时调用
  inserted: function (el, binding) {
    // 聚焦元素
    binding.addClass = () => {
      const { x } = el.getBoundingClientRect()
      const h = document.documentElement.clientWidth || document.body.clientWidth;
      if (x < (h / 2)) {
        if (el.className.indexOf(binding.value) == -1) {
          // 下面单引号中间是一个空格
          el.className = binding.value + ' ' + el.className
        }
        if (binding.addClass) {
          window.removeEventListener('scroll', binding.addClass)
        }
      }
    }
    window.addEventListener('scroll', binding.addClass, true)

    binding.addClass()
  },
  unbind: function (el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass)
    }
  }
}
)
// Vue.use(Element)
// Vue.prototype.post = postApi
// Vue.prototype.qs = qs
// Vue.prototype.$axios = axios
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.baseURL = ''
// Vue.config.productionTip = false

//路由守卫
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
//   next()
//   /* if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
//     if (localStorage.getItem('xx')) {  // 获取当前的token和uid是否存在
//       next();
//     }
//     else {

//     }
//   }
//   else {
//     next();
//   } */
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
// new Vue({
//   el: '#app',
//   store,
//   router,
//   components: { App },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js